(function(){
    // Your JavaScript here
    console.log('Ellie Active');
    console.log('plans.js');

    document.addEventListener('DOMContentLoaded', hideAccessories);
    document.addEventListener('DOMContentLoaded', checkCartContents);
    document.addEventListener('DOMContentLoaded', getCartContents);

    function hideAccessories() {
       $('.maybe_hide_me').hide();
    }

    console.log('i am here');

    var funkyCartCount = 0;
    funkyCartCount = checkCartContents();

    function checkCartContents() {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          funkyCartCount = parseInt(cart.item_count);
          return funkyCartCount;
        }
      });
    }

    var myCartContents = "";
    myCartContents = getCartContents();

    function getCartContents () {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cartData) {
          myCartContents = cartData;
          return myCartContents;
        }
      });
    }



    function sleep(milliseconds) {
      var start = new Date().getTime();
      for (var i =0; i < 1e7; i ++){
        if ((new Date().getTime() - start) > milliseconds) {
          break;
        }
      }
    }

/*
    function cartItemCount() {
      jQuery.getJSON('/cart.js', function(cart) {
           alert('There are now ' + cart.item_count + ' items in the cart.');
           var my_count;
           alert(JSON.stringify(cart));
           my_count = cart.item_count;
          return my_count;
          } );

    } */


// ** NEED TO UPDATE ONCE WE SET UP THE BACK END **
    $('#ChoosePlanAddToCartForm').on('submit', function(e) {
      e.preventDefault();

      var subscription_id = $('#product_form_variant_subscription_id #subscription_id').val();
      // var variant_id = $('#product_form_variant_subscription_id #variant_id').val();
      var variant_id = $('#prepaidProductChosen').val() ? $('#prepaidProductChosen').val() : $('#product_form_variant_subscription_id #variant_id').val(); //TODO: Prepaid
      var sku_id = $('#product_form_variant_subscription_id #sku_id').val();
      var product_collection = $('#product_form_variant_subscription_id #collection_info').val();

      var referrer = localStorage.getItem('referrer');
      // console.log('variant_id', variant_id)

//       var my_bra_size = $( "select[name='Sports Bra'] option:selected" ).val();
//       var my_top_size = $( "select[name='Top'] option:selected" ).val();
//       var my_bottom_size = $( "select[name='Bottom'] option:selected" ).val();
//       var my_jacket_size = $( "select[name='Jacket'] option:selected" ).val();
//       var my_gloves_size = $( "select[name='Gloves'] option:selected" ).val();

      var my_bra_size = $( ".tag-row[aria-type='sports-bra'] input:checked" ).val();
      var my_top_size = $( ".tag-row[aria-type='top'] input:checked" ).val();
      var my_bottom_size = $( ".tag-row[aria-type='bottom'] input:checked" ).val();
      var my_jacket_size = $( ".tag-row[aria-type='jacket'] input:checked" ).val();
      var my_gloves_size = $(".tag-row[aria-type='gloves'] input:checked").val();

//       var choose_bra = $( "select[name='Sports Bra']" ).length > 0;
//       var choose_top = $( "select[name='Top']" ).length > 0;
//       var choose_bottom = $( "select[name='Bottom']" ).length > 0;
//       var choose_jacket = $( "select[name='Jacket']" ).length > 0;
//       var choose_gloves = $( "select[name='Gloves']" ).length > 0;

      var choose_bra = $( ".tag-row[aria-type='sports-bra']" ).length > 0;
      var choose_top = $( ".tag-row[aria-type='top']" ).length > 0;
      var choose_bottom = $( ".tag-row[aria-type='bottom']" ).length > 0;
      var choose_jacket = $( ".tag-row[aria-type='jacket']" ).length > 0;
      var choose_gloves = $( ".tag-row[aria-type='gloves']" ).length > 0;

      var product_id = $('#product_form_variant_subscription_id #product_id').val();

      //TODO: prepaid purchase added 9/10/18
      // var charge_interval_frequency = $('#prepaidSubscription').prop('checked') ? 3 : 1;
      var charge_interval_frequency;

      if ($('#prepaidProductChosen').val() && $('#prepaidSubscription').prop('checked')) {
        charge_interval_frequency = 3;
      } else {
        charge_interval_frequency = 1;
      }

      // if ((my_jacket_size == null) || (my_jacket_size == '')) {
      //    my_jacket_size = 'no_jacket_size';

      // }

      // var threeItemSelected = $('.chooseThreeOrFiveItems').val() ? $('.chooseThreeOrFiveItems').val().indexOf('3') > -1 : true;

      // var twoItemSelected =  $('.chooseThreeOrFiveItems').val().indexOf('2') > -1;
      var threeItemSelected;
      var twoItemSelected;

      $('.chooseThreeOrFiveItems').each(function() {
				if ($(this).hasClass('focus')) {
					if ($(this).find('.subType').val().indexOf('3') > -1) {
            console.log('3 selected')
						threeItemSelected = true;
					} else if ($(this).find('.subType').val().indexOf('2') > -1) {
            console.log('2 selected')
						twoItemSelected = true;
					}
				}
			})

      console.log(JSON.stringify(twoItemSelected));
      console.log('jackets-ze', my_jacket_size);

      if (twoItemSelected  !== true) {

        if (choose_bra && !my_bra_size) {
          alert("Please Choose a Bra Size");
          return false;
        }
      }
      
      if (twoItemSelected  !== true) { 
        if (choose_top && !my_top_size) {
         alert("Please Choose a Top Size");
         return false;
        }
      }
      if (choose_bottom && !my_bottom_size) {
       alert("Please Choose a Leggings Size");
       return false;
      }
      if (twoItemSelected  !== true) {
        if (choose_jacket && !my_jacket_size) {
         alert("Please Choose a Jacket Size");
         return false;
        }
      }
      if (choose_gloves && !my_gloves_size && !threeItemSelected && !twoItemSelected) {
       alert("Please Choose a Gloves Size");
       return false;
      }

      // TODO: one-off purchcase
      var one_off_product = $('#product_one_off').val();
      var data1;



      if (one_off_product) {
        data1 = {
          "quantity": 1,
          "id": variant_id,
          "properties[shipping_interval_frequency]": 1,
          "properties[shipping_interval_unit_type]": "Months",
          "properties[product_collection]": product_collection,
          "properties[charge_interval_frequency]": charge_interval_frequency, //TODO: prepaid purchase added 9/10/18
          "properties[charge_interval_unit_type]": "Months",
          "properties[main-product]": true,
          "properties[leggings]": my_bottom_size,
          "properties[tops]": my_top_size,
          "properties[sports-bra]": my_bra_size,
          "properties[sports-jacket]": my_jacket_size,
          "properties[gloves]": my_gloves_size,
          "properties[referrer]": referrer,
          "properties[product_id]": product_id, //TODO: prepaid
          "properties[number_charges_until_expiration]": 1
        };
      } else {
        data1 = {
          "quantity": 1,
          "id": variant_id,
          "properties[shipping_interval_frequency]": 1,
          "properties[shipping_interval_unit_type]": "Months",
          "properties[product_collection]": product_collection,
          "properties[charge_interval_frequency]": charge_interval_frequency, //TODO: prepaid purchase added 9/10/18
          "properties[charge_interval_unit_type]": "Months",
          "properties[main-product]": true,
          "properties[leggings]": my_bottom_size,
          "properties[tops]": my_top_size,
          "properties[sports-bra]": my_bra_size,
          "properties[sports-jacket]": my_jacket_size,
          "properties[gloves]": my_gloves_size,
          "properties[referrer]": referrer,
          "properties[product_id]": product_id //TODO: prepaid
        };
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data1,
        dataType: 'json',
        success: function() {
          if (funkyCartCount == 0) {
            var custid = document.getElementById("cust_id").value;
            var custemail = document.getElementById("cust_email").value;
            var customer_param = ""
            if (custid == "" || custemail == "") {
              customer_param = "";
            } else {
              customer_param = "customer_id=" + custid + "&customer_email=" + custemail;
            }
            function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
            do{
                token=get_cookie('cart');
                }
                while(token == undefined);

                // var myshopify_domain='elliestaging.myshopify.com';
                var myshopify_domain='ellie.com';
                try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
            checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;
            // window.location = checkout_url;
            window.location = "/cart"
          } else {
            window.location = "/cart"
          } ;  //end if funkyCartCount == 0
        },
        error: function(data){
          alert("Sorry there was an error, please call customer service: 1 (844) 338-5044");
        }
       });

       $('#prod-choice-submit').prop('disabled', 'true');
       sleep(3000);

      })

      $('#ChoosePastCollectionAddToCartForm').on('submit', function(e) {
        e.preventDefault();

        var subscription_id = $('#product_form_variant_subscription_id #subscription_id').val();
        var variant_id = $('#product_form_variant_subscription_id #variant_id').val();
        var sku_id = $('#product_form_variant_subscription_id #sku_id').val();
        var product_collection = $('#product_form_variant_subscription_id #collection_info').val();

        var referrer = localStorage.getItem('referrer');

        // console.log('variant_id', variant_id)

        // var my_bra_size = $( "select[name='Sports Bra'] option:selected" ).val();
        // var my_top_size = $( "select[name='Top'] option:selected" ).val();
        // var my_bottom_size = $( "select[name='Bottom'] option:selected" ).val();
        // var my_jacket_size = $( "select[name='Jacket'] option:selected" ).val();
        // var my_wrap_size = $("select[name='Cozy Wrap'] option:selected").val();
        //
        // var choose_bra = $( "select[name='Sports Bra']" ).length > 0;
        // var choose_top = $( "select[name='Top']" ).length > 0;
        // var choose_bottom = $( "select[name='Bottom']" ).length > 0;
        // var choose_jacket = $( "select[name='Jacket']" ).length > 0;
        // var choose_wrap = $("select[name='Cozy Wrap']").length > 0;

        var my_bra_size = $( ".tag-row[aria-type='sports-bra'] input:checked" ).val();
        var my_top_size = $( ".tag-row[aria-type='top'] input:checked" ).val();
        var my_bottom_size = $( ".tag-row[aria-type='bottom'] input:checked" ).val();
        var my_jacket_size = $( ".tag-row[aria-type='jacket'] input:checked" ).val();
        var my_gloves_size = $(".tag-row[aria-type='gloves'] input:checked").val();

        var choose_bra = $( ".tag-row[aria-type='sports-bra']" ).length > 0;
        var choose_top = $( ".tag-row[aria-type='top']" ).length > 0;
        var choose_bottom = $( ".tag-row[aria-type='bottom']" ).length > 0;
        var choose_jacket = $( ".tag-row[aria-type='jacket']" ).length > 0;
        var choose_gloves = $( ".tag-row[aria-type='gloves']" ).length > 0;

        // if ((my_jacket_size == null) || (my_jacket_size == '')) {
        //    my_jacket_size = 'no_jacket_size';

        // }
        
        console.log('rvhandle', $('.product_section').attr('data-rv-handle'))
        var twoItemOneTimePurchase = $('.product_section').attr('data-rv-handle').indexOf('2-item') > -1 ? true : false;
        
        
        if (twoItemOneTimePurchase === false) {
          if (choose_bra && !my_bra_size) {
            alert("Please Choose a Bra Size");
            return false;
           }
        }
        
        if (choose_top && !my_top_size) {
         alert("Please Choose a Top Size");
         return false;
        }
        if (choose_bottom && !my_bottom_size) {
         alert("Please Choose a Leggings Size");
         return false;
        }
        if (choose_jacket && !my_jacket_size) {
         alert("Please Choose a Jacket Size");
         return false;
        }
        if (choose_gloves && !my_gloves_size) {
          alert("Please Choose a Gloves Size");
          return false;
        }

        var data1 = {
          "quantity": 1,
          "id": variant_id,
          "properties[shipping_interval_frequency]": 1,
          "properties[shipping_interval_unit_type]": "Months",
          "properties[product_collection]": product_collection,
          "properties[charge_interval_frequency]": 1,
          "properties[charge_interval_unit_type]": "Months",
          "properties[main-product]": true,
          "properties[leggings]": my_bottom_size,
          "properties[tops]": my_top_size,
          "properties[sports-bra]": my_bra_size,
          "properties[sports-jacket]": my_jacket_size,
          "properties[gloves]": my_gloves_size,
          "properties[number_charges_until_expiration]": 1,
          "properties[referrer]": referrer
        };

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data1,
          dataType: 'json',
          success: function() {
            if (funkyCartCount == 0) {
              var custid = document.getElementById("cust_id").value;
              var custemail = document.getElementById("cust_email").value;
              var customer_param = ""
              if (custid == "" || custemail == "") {
                customer_param = "";
              } else {
                customer_param = "customer_id=" + custid + "&customer_email=" + custemail;
              }
              function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
              do{
                  token=get_cookie('cart');
                  }
                  while(token == undefined);

                  // var myshopify_domain='elliestaging.myshopify.com';
                  var myshopify_domain = 'ellie.com';
                  try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
              checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;
              // window.location = checkout_url;
              window.location = "/cart"
            } else {
              window.location = "/cart"
            } ;  //end if funkyCartCount == 0
          },
          error: function(data){
            alert("Sorry there was an error, please call customer service: 1 (844) 338-5044");
          }
         });

        $('#prod-choice-submit').prop('disabled', 'true');
         sleep(3000);

      })


      //Floyd Wallace 11-20-2017 Added to make shopify cart redirect to ReCharge checkout_url
      $('#StaticCartSubmit').on('submit', function(e) {
        e.preventDefault();

        var formData = myCartContents;
        var custid = document.getElementById("cust_id").value;
        var custemail = document.getElementById("cust_email").value;
        var customer_param = ""
        if (custid == "" || custemail == "") {
          customer_param = "";
        } else {
          customer_param = "customer_id=" + custid + "&customer_email=" + custemail;
        }
        function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
        do {
          token=get_cookie('cart');
        }
        while(token == undefined);

        // var myshopify_domain='elliestaging.myshopify.com';
        var myshopify_domain = 'ellie.com';
        try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }

        checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;

        // window.location = checkout_url;
        // window.location = "/cart"
        window.location = "/checkout";
      })


      //Floyd Wallace 11-20-2017 Added to make add ons have only one charge not recurring_price
      $('#ChooseStaticProductAddToCartForm').on('submit', function(e) {
        e.preventDefault();

        var product_title = $('.product-title').val();
        var shopify_product_id = $('#product_hidden_form #shopify_product_id').val();
        var price = $('#product_hidden_form #shopify_product_price').val();
        var quantity = $('.quantity-input').val();
        // var size = $('.option-select-input').val();
        var size = $('.option-value-input:checked').val();
        var shopify_variant_id;
        var referrer = localStorage.getItem('referrer');

        $('.product-options select[name="id"] option').each(function() {
          var $this = $(this);
          var option = $this.html().split(' - ')[0].split(' /')[0].trim(); // edited to account for color variant 5-7-2018

          if (option == size) {
            shopify_variant_id = $this.val();
            return false;
          }
        })
        // console.log('shopify_variant_id', shopify_variant_id);

        var formData = {
          "quantity": quantity,
          "id": shopify_variant_id, //?? or variant?
          "product_title": product_title,
          "price": price,
          "shopify_variant_id": shopify_variant_id,
          "properties[shipping_interval_frequency]": 1,
          "properties[shipping_interval_unit_type]": "Months",
          "properties[charge_interval_frequency]": 1,
          "properties[charge_interval_unit_type]": "Months",
          "properties[order_interval_frequency]": 1,
          "properties[order_interval_unit]": "month",
          "properties[number_charges_until_expiration]": 1,
          "properties[referrer]": referrer
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: formData,
          dataType: 'json',
          success: function() {
            $('.product-form-inline-atc-button').prop('disabled', 'true');
            if (funkyCartCount == 0) {
              var custid = document.getElementById("cust_id").value;
              var custemail = document.getElementById("cust_email").value;
              var customer_param = ""
              if (custid == "" || custemail == "") {
                customer_param = "";
              } else {
                customer_param = "customer_id=" + custid + "&customer_email=" + custemail;
              }
              function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
              do{
                token=get_cookie('cart');
              }
              while(token == undefined);

              // var myshopify_domain='elliestaging.myshopify.com';
              var myshopify_domain = 'ellie.com';
              try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }

              checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;

              // window.location = checkout_url;
              window.location = "/cart"
            } else {
              window.location = "/cart"
            } ;  //end if funkyCartCount == 0
          },
          error: function(data){
            // console.log('data.status', data.status, data.responseText)
            if (data.status == 422) {
              alert(data.responseJSON.description);
            }
            else {
              alert("Sorry there was an error, please call customer service: 1 (844) 338-5044");
              return false;
            }

          }
       });
      })


    $('#ChooseProductAddToCartForm').on('submit', function(e) {
      e.preventDefault();

      var product_title = $('.product-title').val();
      var shopify_product_id = $('#product_hidden_form #shopify_product_id').val();
      var price = $('#product_hidden_form #shopify_product_price').val();
      var quantity = $('.quantity-input').val();
      var size = $('.option-select-input').val();
      var shopify_variant_id;
      $('.product-options select[name="id"] option').each(function() {
        var $this = $(this);
        if ($this.html().indexOf(size) > -1) {
          shopify_variant_id = $this.val();
        }
      })
      var referrer = localStorage.getItem('referrer');

      // console.log('shopify_variant_id', shopify_variant_id);

      var formData = {
        "quantity": quantity,
        "id": shopify_variant_id, //?? or variant?
        "product_title": product_title,
        "price": price,
        "shopify_variant_id": shopify_variant_id,
        "properties[shipping_interval_frequency]": 1,
        "properties[shipping_interval_unit_type]": "Months",
        "properties[charge_interval_frequency]": 1,
        "properties[charge_interval_unit_type]": "Months",
        "properties[referrer]": referrer
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function() {
          if (funkyCartCount == 0) {
            var custid = document.getElementById("cust_id").value;
            var custemail = document.getElementById("cust_email").value;
            var customer_param = ""
            if (custid == "" || custemail == "") {
              customer_param = "";
            } else {
              customer_param = "customer_id=" + custid + "&customer_email=" + custemail;
            }

            function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
            do{
              token=get_cookie('cart');
            }
            while(token == undefined);

            // var myshopify_domain='elliestaging.myshopify.com';
            var myshopify_domain = 'ellie.com';
            try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
            checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+"&"+customer_param;
            // window.location = checkout_url;
            window.location = "/cart"
          } else {
            window.location = "/cart"
          };  //end if funkyCartCount == 0
        },
        error: function(data){
          // console.log('data.status', data.status, data.responseText)
          alert("Sorry there was an error, please call customer service: 1 (844) 338-5044");
        }
     });

    })

  })();
